import { ProductByCategory } from 'components/main-page/home-page/product-by-category/ProductByCategory'
import { useEffect, useState } from 'react'
import { constructOptionMultipleSelect, convertErrorMessage, getValueFromArray } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_PRODUCT_BY_CATEGORY } from 'services/api-home-page/apiProductByCategory'
import { Alert } from 'avo-ui'

const INITIAL_STATE = {
    is_show: false,
    title: null,
    categories: [
        {
            category_name: null,
            product_ids: [],
        },
    ],
}

const GET_FIELD_NAME = {
    title: 'Title',
    categories: 'Product by category item',
}

const GET_ITEM_FIELD_NAME = {
    category_name: 'Title',
    product_ids: 'Product list',
}

export const ProductByCategoryContainer = () => {
    const [reload, setReload] = useState(false)
    const [productByCategoryDetail, setProductByCategoryDetail] = useState(INITIAL_STATE)
    const [errorForm, setErrorForm] = useState({})
    const { fetching: getProductByCategoryDetail, isLoading } = useFetch(API_PRODUCT_BY_CATEGORY.DETAIL)
    const { fetching: updateProductByCategory, isLoading: isUpdating } = useFetch(API_PRODUCT_BY_CATEGORY.UPDATE)

    const onChangeForm = (item) => {
        setProductByCategoryDetail({ ...productByCategoryDetail, ...item })
    }

    const validateForm = () => {
        const validateProductByCategoryItems = () => {
            const result = []
            productByCategoryDetail?.categories?.map((item, index) => {
                Object.keys(item).forEach((key) => {
                    if (GET_ITEM_FIELD_NAME[key] && (!item[key] || item[key]?.length === 0)) {
                        result.push({ index, key, message: `${GET_ITEM_FIELD_NAME[key]} wajib diisi` })
                    }
                })
            })
            return result
        }

        return new Promise((resolve, reject) => {
            const errors = {}
            Object.keys(productByCategoryDetail).forEach((key) => {
                if (
                    GET_FIELD_NAME[key] &&
                    (!productByCategoryDetail[key] || productByCategoryDetail[key]?.length === 0)
                ) {
                    errors[key] = `${GET_FIELD_NAME[key]} wajib diisi`
                } else if (key === 'categories' && validateProductByCategoryItems()?.length) {
                    errors['categories_detail'] = validateProductByCategoryItems()
                }
            })

            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = () => {
        validateForm().then(() => {
            const newPayload = {
                ...productByCategoryDetail,
                categories: productByCategoryDetail?.categories?.map((item, index) => {
                    return {
                        ...item,
                        product_ids: getValueFromArray(item?.product_ids, 'value'),
                        sequence: index,
                    }
                }),
            }
            updateProductByCategory(newPayload)
                .then(() => {
                    setReload(!reload)
                    return Alert({
                        icon: 'success',
                        title: 'Success',
                        message: 'Product By Category Updated !',
                    })
                })
                .catch((error) => setErrorForm(convertErrorMessage(error?.data, GET_FIELD_NAME, GET_ITEM_FIELD_NAME)))
        })
    }

    useEffect(() => {
        getProductByCategoryDetail().then((response) => {
            const newDetail = {
                ...response?.data,
                categories: response?.data?.categories?.map((item) => {
                    const { products, ...itemRest } = item
                    return {
                        ...itemRest,
                        product_ids: constructOptionMultipleSelect(products, 'name', 'id'),
                    }
                }),
            }
            setProductByCategoryDetail(newDetail)
        })
    }, [reload])

    const props = {
        sectionProps: {
            productByCategoryDetail,
            onChangeForm,
            errorForm,
        },
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <ProductByCategory {...props} />
}
